import { useEffect, useState } from "react";

export const POLL_KEY = "poll_votes_v1";

export function getPollVotes() {
  try {
    return JSON.parse(localStorage.getItem(POLL_KEY) || "[]");
  } catch {
    return [];
  }
}

export function savePollVote(row) {
  const votes = getPollVotes();
  const vid = row["VID"];
  if (!votes.find((v) => v["VID"] === vid)) {
    votes.push(row);
    localStorage.setItem(POLL_KEY, JSON.stringify(votes));
    return true; // newly added
  }
  return false; // already existed
}

export function normalize(text) {
  return (text || "").toString().toLowerCase().replace(/\s+/g, " ").trim();
}

export function useVoterData() {
  const [data, setData] = useState([]);
  useEffect(() => {
    fetch("/voters_final1.json")
      .then((r) => r.json())
      .then(setData)
      .catch(console.error);
  }, []);
  return data;
}

export function useSearch(data) {
  const [searchName, setSearchName] = useState("");
  const [searchRname, setSearchRname] = useState("");
  const [searchVid, setSearchVid] = useState("");

  const hasQuery =
    searchName.length > 0 || searchRname.length > 0 || searchVid.length > 0;

  const filtered = hasQuery
    ? data.filter((row) => {
        const vname = normalize(row["VNAMEENG"]);
        const rname = normalize(row["RNAMEENG"]);
        const vid   = normalize(row["VID"]);
        const qName  = normalize(searchName);
        const qRname = normalize(searchRname);
        const qVid   = normalize(searchVid);
        return (
          (qName  === "" || vname.startsWith(qName)) &&
          (qRname === "" || rname.startsWith(qRname)) &&
          (qVid   === "" || vid.startsWith(qVid))
        );
      })
    : [];

  return {
    searchName, setSearchName,
    searchRname, setSearchRname,
    searchVid, setSearchVid,
    hasQuery, filtered,
  };
}

export function cardKeys(row) {
  return Object.keys(row).filter(
    (key) =>
      key &&
      key.trim() !== "" &&
      !key.startsWith(" ") &&
      !key.toUpperCase().startsWith("BLANK") &&
      key !== "VNAMEENG" &&
      key !== "RNAMEENG" &&
      key !== "MUNICIPAL" &&
      key !== "BOOTHNO" &&
      key !== "BOOTHNAME" &&
      key !== "ADDRESS" &&
      key !== "WARDNO"
  );
}

// Shared search bar UI
export function SearchBars({ searchName, setSearchName, searchRname, setSearchRname, searchVid, setSearchVid }) {
  return (
    <div className="row mb-2 g-2">
      <div className="col-md-4">
        <label className="form-label fw-semibold small text-secondary mb-1">
          👤 Voter Name (VNAMEENG)
        </label>
        <input
          type="text"
          className="form-control"
          placeholder="Search by voter name..."
          value={searchName}
          onChange={(e) => setSearchName(e.target.value)}
        />
      </div>
      <div className="col-md-4">
        <label className="form-label fw-semibold small text-secondary mb-1">
          👨‍👦 Relative Name (RNAMEENG)
        </label>
        <input
          type="text"
          className="form-control"
          placeholder="Search by relative name..."
          value={searchRname}
          onChange={(e) => setSearchRname(e.target.value)}
        />
      </div>
      <div className="col-md-4">
        <label className="form-label fw-semibold small text-secondary mb-1">
          🪪 Voter ID (VID)
        </label>
        <input
          type="text"
          className="form-control"
          placeholder="Search by voter ID..."
          value={searchVid}
          onChange={(e) => setSearchVid(e.target.value)}
        />
      </div>
    </div>
  );
}
